import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsCart = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>





<g fill="currentColor">
	<path d="M23.133791,3.9639111c-0.0929413-0.1040058-0.2102242-0.1615403-0.3252945-0.1615403H5.3311372L4.3862357,1.1469097
		C4.3264885,0.9787298,4.1560965,0.8481704,3.994556,0.8481704H0.7659575v0.3363587h0.0022137v0.6107556h2.9763293
		c0.535517,1.5113996,1.0710351,3.0228004,1.6087658,4.5319862c0.5421567,1.5313163,1.0865269,3.0604186,1.6286836,4.5917354
		l0.7678709,2.2062454l-1.2392149,3.3724346c-0.0619621,0.143837-0.0486836,0.3031654,0.0331931,0.4293003
		c0.0818772,0.1261349,0.2035856,0.1991596,0.3297191,0.2013721h0.0022135l8.904645-0.0531101h4.146944
		c0.0531101,0,0.0951538-0.0110645,0.1283474-0.0354061c0.0486832-0.0132771,0.0929413-0.0376186,0.1239204-0.0730247
		c0.0929413-0.1040058,0.0929413-0.2566929,0.0929413-0.3784027v-0.0508957c0-0.1261349,0-0.2456303-0.0685978-0.3230801
		l-0.008852-0.0110645l-0.0132771-0.0066395c-0.0531101-0.0309811-0.1172829-0.0641727-0.2102242-0.0641727H7.5196791
		l0.9670305-2.6311207l12.8125992-1.1595516c0.18367-0.0022125,0.3341446-0.1416254,0.3651257-0.3385715l1.5578709-7.661005
		C23.2510738,4.2338834,23.2289448,4.0701294,23.133791,3.9639111z M20.8943501,11.5275488h0.0000019L8.44909,12.6605463
		L5.6564302,4.749485h16.6187592L20.8943501,11.5275488z"/>
	<path d="M8.76332,18.133009L8.76332,18.133009c-0.6660776,0-1.2967496,0.2611198-1.7703071,0.7368889
		c-0.47577,0.475771-0.7391028,1.1042309-0.7391028,1.7725201c0,1.3830528,1.1263576,2.5094109,2.5094099,2.5094109
		c0.6660795,0,1.296751-0.2611198,1.7703075-0.7368889c0.47577-0.475771,0.7391043-1.1042309,0.7391043-1.7725201
		s-0.2611208-1.2967491-0.7391043-1.7725201C10.060071,18.3941307,9.4293995,18.133009,8.76332,18.133009z M8.76332,22.2157803
		c-0.8541727,0-1.5755734-0.7213993-1.5755734-1.5755749c0-0.8541737,0.7214007-1.575573,1.5755734-1.575573
		c0.8541746,0,1.5755739,0.7213993,1.5755739,1.575573C10.3388939,21.5098686,9.6329851,22.2157803,8.76332,22.2157803z"/>
	<path d="M17.5108509,18.155138c-0.6616535,0-1.2834721,0.2589073-1.754817,0.7302513
		c-0.471344,0.471344-0.7324638,1.095377-0.7324638,1.7570305c0,1.3719883,1.1152945,2.4872818,2.4872828,2.4872818
		c0.6616535,0,1.2834721-0.2589073,1.7548161-0.7302513s0.7324638-1.095377,0.7324638-1.7570305
		C19.9981327,19.2704315,18.8828392,18.155138,17.5108509,18.155138z M17.5108509,22.2356968
		c-0.8652363,0-1.597702-0.7324638-1.597702-1.5977039c0-0.8807278,0.7169743-1.597702,1.597702-1.597702
		c0.8652382,0,1.5977039,0.7324638,1.5977039,1.597702C19.1085548,21.5187206,18.3915787,22.2356968,17.5108509,22.2356968z"/>
</g>


    
    </SvgIcon>
  );
});

export default AppIconsCart;
